import * as React from 'react'

import { Switch as SwitchPrimitive } from 'radix-ui'

import { cn } from './cn'

export interface SwitchProps {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (
    event: { target: { checked: boolean; name?: string } },
    checked: boolean,
  ) => void
  disabled?: boolean
  name?: string
  id?: string
  size?: 'small' | 'medium'
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'
  className?: string
  inputProps?: Record<string, unknown>
  'aria-label'?: string
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  (
    {
      checked,
      defaultChecked,
      onChange,
      disabled,
      name,
      id,
      size = 'medium',
      color = 'primary',
      className,
      inputProps,
      ...props
    },
    ref,
  ) => (
    <SwitchPrimitive.Root
      ref={ref}
      id={id}
      name={name}
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={(next) =>
        onChange?.({ target: { checked: next, name } }, next)
      }
      disabled={disabled}
      className={cn(
        'relative inline-flex shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200',
        size === 'small' ? 'h-5 w-9' : 'h-6 w-11',
        'bg-black/[0.15] data-[state=checked]:bg-primary dark:bg-white/[0.18]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 focus-visible:ring-offset-paper',
        'disabled:pointer-events-none disabled:opacity-40',
        className,
      )}
      {...(inputProps as object)}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          'block rounded-full bg-white shadow-menu transition-transform duration-200',
          size === 'small'
            ? 'h-4 w-4 translate-x-0.5 data-[state=checked]:translate-x-[18px]'
            : 'h-5 w-5 translate-x-0.5 data-[state=checked]:translate-x-[22px]',
        )}
      />
    </SwitchPrimitive.Root>
  ),
)
Switch.displayName = 'Switch'

export default Switch
